module.exports = __webpack_public_path__ + "img/cancelamento-protesto.ba08ac48.png";